// @flow
import * as React from 'react';
import FunctionalLink from './FunctionalLink';
import styles from './SeeAllLink.less';

type Props = {|
  onClick?: (SyntheticMouseEvent<HTMLAnchorElement>) => mixed,
  children: React.Node,
|};

const SeeAllLink = ({ onClick, children }: Props) => (
  <FunctionalLink onClick={onClick} className={styles.see_all}>
    {children}
  </FunctionalLink>
);

export default SeeAllLink;
